import { useJfGlobalProject } from '@core/rc-state';
import { getUserInfo } from '../../..';
var getIsPermission = function getIsPermission(companies, companyRoles) {
  if (!companies || Array.isArray(companies) && companies.length === 0) {
    return false;
  }
  if (!companyRoles || Array.isArray(companyRoles) && companyRoles.length === 0) {
    return false;
  }
  var defaultCompId = getUserInfo().defaultCompId;
  var _ref = companies.find(function (item) {
      return item.companyId === defaultCompId;
    }) || {},
    _companyRoles = _ref.companyRoles;
  if (!_companyRoles || _companyRoles.length === 0) {
    return false;
  }
  return _companyRoles.some(function (companie) {
    return companyRoles.includes(companie);
  });
};
export function useProjectValue(enable, options) {
  var _ref2 = options || {},
    companyRoles = _ref2.companyRoles;
  var _useJfGlobalProject = useJfGlobalProject({
      initProject: true
    }),
    project = _useJfGlobalProject.project;
  var isPermission = !companyRoles ? true : getIsPermission(project === null || project === void 0 ? void 0 : project.companies, companyRoles);
  var data = enable && isPermission ? {
    projectId: project === null || project === void 0 ? void 0 : project.id,
    projectName: project === null || project === void 0 ? void 0 : project.name,
    projectCode: project === null || project === void 0 ? void 0 : project.code
  } : {};
  // const _isPermission = project. && project?.id;
  return {
    projectInitialValues: data,
    project: data
  };
}